module.exports = __webpack_public_path__ + "img/Jasper - Pointing NW.8fac6930.png";